(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["belly-card-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const fine = window.matchMedia('(hover:hover) and (pointer:fine)');
  function prepare(root) {
    root.querySelectorAll('[data-belly-card-preview]').forEach(media => {
      if (media.dataset.ready) return;
      media.dataset.ready = 'true';
      const contacts = new Set();
      const supportsTouchEvents = 'ontouchstart' in window;
      let hovering = false, pointing = false, keyboard = false;
      const render = () => {
        const active = hovering || pointing || contacts.size > 0 || keyboard;
        media.classList.toggle('is-photo', active);
        media.setAttribute('aria-pressed', String(active));
      };
      const reset = () => {
        contacts.clear();
        hovering = pointing = keyboard = false;
        render();
      };
      media.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && fine.matches) { hovering = true; render(); }
      });
      media.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') hovering = false;
        render();
      });
      media.addEventListener('pointerdown', event => {
        keyboard = false;
        if (event.pointerType === 'pen' || (event.pointerType === 'touch' && !supportsTouchEvents)) pointing = true;
        render();
      }, { passive: true });
      const releasePointer = () => { pointing = false; render(); };
      document.addEventListener('pointerup', releasePointer, { passive: true });
      document.addEventListener('pointercancel', releasePointer, { passive: true });
      media.addEventListener('touchstart', event => {
        hovering = pointing = keyboard = false;
        for (const touch of event.changedTouches) contacts.add(touch.identifier);
        render();
      }, { passive: true });
      const releaseTouch = event => {
        for (const touch of event.changedTouches) contacts.delete(touch.identifier);
        render();
      };
      document.addEventListener('touchend', releaseTouch, { passive: true });
      document.addEventListener('touchcancel', releaseTouch, { passive: true });
      media.addEventListener('blur', () => { keyboard = false; render(); });
      media.addEventListener('keydown', event => { if (event.key === 'Escape') reset(); });
      media.addEventListener('click', event => {
        if (event.detail === 0 && !event.sourceCapabilities?.firesTouchEvents && event.pointerType !== 'touch') {
          keyboard = !keyboard;
          render();
        }
      });
      window.addEventListener('blur', reset);
      document.addEventListener('visibilitychange', () => { if (document.hidden) reset(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepare(document));
  else prepare(document);
  document.addEventListener('shopify:section:load', event => prepare(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
